<template>
    <div class="box">
        <ul>
            <li class="weixin">
            	<div class="weixin-logo"></div>
            </li>
			<li class="app">
            	<div class="app-logo"></div>
            </li>
            <li class="idea" @click="toTop"></li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'xuanfu',
        data () {
            return {
                
            }
		},
		mounted() {
		　　// 此处true需要加上，不加滚动事件可能绑定不成功
			window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			toTop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果 
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
				clearInterval(timeTop);
				}
			}, 5);
		}
	}
}
</script>
<style scoped>
.box {
	width: 52px;
	height: 152px;
	position:fixed;
	top:60%;
    right:50px;
    z-index: 999;
}
.box ul li {
	width: 50px;
	display: block;
	height: 46px;
	padding: 2px;
    overflow: hidden;
    margin-bottom: 5px;
}
.weixin {
	background: url("../../assets/images/xuebi2.png") no-repeat;
	background-position: 0 44%;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
}
.weixin:hover {
	background-position: 0 52%
}
.weixin:hover .weixin-logo {
	width: 150px;
	height: 97px;
}
.idea {
	background: url("../../assets/images/xuebi2.png") no-repeat;
	background-position: 0 76.5%;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
}
.idea:hover {
	background-position: 0 85%;
}
.app {
	background: url("../../assets/images/xuebi2.png") no-repeat;
	background-position: 0 60%;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
}
.app:hover {
	background-position: 0 68%;
}
.app:hover .app-logo {
	width: 150px;
	height: 97px;
	-webkit-transform: rotate(360deg);
	-moz-transform: rotate(360deg);
	-ms-transform: rotate(360deg);
	-o-transform: rotate(360deg);
}
.weixin-logo {
	background: url("../../assets/images/xuebi2.png") no-repeat;
	background-position: 50% 0;
	width: 0px;
	height: 0px;
	overflow: hidden;
	position: absolute;
	top: -51px;
    left: -150px;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
}
.app-logo {
	background: url("../../assets/images/xuebi2.png") no-repeat;
	background-position: 50% 15%;
	width: 0px;
	height: 0px;
	overflow: hidden;
	position: absolute;
	top: 0px;
    left: -150px;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
}
</style>


// WEBPACK FOOTER //
// src/components/commn/xuanfu.vue